import { useViewRuntimeContext } from "@/components/common/view-runtime-context";
import { useShareViewDialog } from "@/features/saved-views/share-view-dialog";
import { selectActiveElementId } from "@/store/selections-selectors";
import { useAppSelector } from "@/store/store-hooks";
import { FaroIconButton, ShareLinkIcon } from "@faro-lotv/flat-ui";
import { assert } from "@faro-lotv/foundation";
import { useCallback, type JSX } from "react";

/**
 * @returns an icon button that opens a share dialog to copy a link to the current view
 */
export function ShareLinkButton(): JSX.Element | null {
  const activeElementId = useAppSelector(selectActiveElementId);
  const viewContext = useViewRuntimeContext();

  const { openShareDialog, shareDialog } = useShareViewDialog();

  const shareCurrentView = useCallback(() => {
    assert(activeElementId, "Active element is required to create deep links");

    openShareDialog({ includeContext: true });
  }, [activeElementId, openShareDialog]);

  // Don't show the share button if the view is not ready as we need the camera
  if (!viewContext.cameras.length) {
    return null;
  }

  return (
    <>
      <FaroIconButton onClick={shareCurrentView} aria-label="deep link">
        <ShareLinkIcon />
      </FaroIconButton>
      {shareDialog}
    </>
  );
}
